import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    approvalflows: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_APPROVALFLOW_SELECT_IDS (store, ids) {
      store.approvalflows.selectIds = ids
    },
    REMOVE_APPROVALFLOW_SELECT_IDS (store, ids) {
      store.approvalflows.selectIds = store.approvalflows.selectIds.filter((v) => { return ids.indexOf(v) === -1 })
    },
    SET_APPROVALFLOW_SELECT_ID (store, id) {
      store.approvalflows.selectId = id
    },
    SET_APPROVALFLOW_FILTERS (store, filters) {
      store.approvalflows.filters = filters
    },
    SET_APPROVALFLOW_PAGINATE (store, val) {
      store.approvalflows.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getApprovalflows: (store, getters) => {
      return store.approvalflows.selectIds.map((id) => {
        return getters['entities/approvalflows/find'](id)
      })
    },
    getApprovalflowsFilters: (store, getters) => {
      return store.approvalflows.filters
    },
    getApprovalflowsPaginate: (store, getters) => {
      return store.approvalflows.paginate
    },
    getApprovalflow: (store, getters) => {
      return getters['entities/approvalflows/find'](store.approvalflows.selectId) || {}
    }
  },
  actions: {
    /*
    selectApprovalflows

    selectApprovalflows ({commit, dispatch, getters, state}, filters) {
      return dispatch('getApprovalflows', filters)
      .then((response) => {
        commit('SET_APPROVALFLOW_FILTERS', filters)
        commit('SET_APPROVALFLOW_PAGINATE', response)
        commit('SET_APPROVALFLOW_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    */
    /*
    refreshSelectApprovalflows

    refreshSelectApprovalflows ({commit, dispatch, getters, state}) {
      return dispatch('selectApprovalflows', getters.getApprovalflowsFilters)
    },
    */
    /*
    selectApprovalflow
    */
    selectApprovalflow ({commit, dispatch, getters, state}, id) {
      return dispatch('getApprovalflowById', id)
      .then((response) => {
        commit('SET_APPROVALFLOW_SELECT_ID', response._id)
        return response
      })
    },
    /*
    resetApprovalflow
    */
    resetApprovalflow ({commit, dispatch, getters, state}) {
      commit('SET_APPROVALFLOW_SELECT_ID', null)
      return null
    },
    /*
    getApprovalflows

    getApprovalflows ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/approvalflows`, {params: filters})
      .then((response) => {
        return dispatch('entities/approvalflows/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.approvalflows || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    */
    /*
    getApprovalflowById
    */
    getApprovalflowById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/approvalflows/${id}`)
      .then((response) => {
        return dispatch('entities/approvalflows/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.approvalflows[0]
      })
    },
    /*
    startApprovalflow
    */
    startApprovalflow ({commit, dispatch, getters, state}, id) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/approvalflows/${id}/start`)
      .then((response) => {
        return dispatch('entities/approvalflows/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeApprovalflow', {})
        return response.approvalflows[0]
      })
    },
    /*
    createApprovalflowResponse
    */
    createApprovalflowResponse ({commit, dispatch, getters, state}, body) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/approvalflows/${body._id}/response`, body)
      .then((response) => {
        return dispatch('entities/approvalflows/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('changeApprovalflow', {})
        return response.approvalflows[0]
      })
    },
    /*
    deleteApprovalflow
    */
    deleteApprovalflow ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/approvalflows/${id}`)
      .then((response) => {
        commit('REMOVE_APPROVALFLOW_SELECT_IDS', [id])
        dispatch('entities/approvalflows/delete', id)
        dispatch('changeApprovalflow', {})
        return {}
      })
    },
    /*
    changeApprovalflow
    */
    changeApprovalflow ({commit, dispatch, getters, state}, data) {
      if (getters.getJob._id) {
        dispatch('getJobById', getters.getJob._id)
      }
      if (getters.getRequisition._id) {
        dispatch('getRequisitionById', getters.getRequisition._id)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Approvalflow.js